import { useApiClient } from '../../hooks/useApiClient';
import { CreateDisparityCalculationFeedback } from '../../types/Feedback/CreateDisparityCalculationFeedback.type';
import { CreateGeneralFeedback } from '../../types/Feedback/CreateGeneralFeedback.type';
import { PresignedPost } from '../../types/PresignedUpload.type';
import { uploadToPresignedPost } from '../../utils/uploadToPresignedPost';

export const useFeedbackApi = () => {
  const apiClient = useApiClient();

  const getPresignedUrl = (file: File): Promise<PresignedPost> => {
    return apiClient('/feedbacks/uploads/presign', {
      method: 'POST',
      body: JSON.stringify({ file_name: file.name, content_type: file.type }),
    });
  };

  return {
    sendFeedback: async (params: CreateGeneralFeedback): Promise<void> => {
      let attachmentPath: string | undefined;
      if (params.attachment) {
        const presignedPost = await getPresignedUrl(params.attachment);
        attachmentPath = await uploadToPresignedPost(presignedPost, params.attachment);
      }

      return apiClient('/feedbacks/general', {
        method: 'POST',
        body: JSON.stringify({
          feedback: params.feedback,
          attachment_path: attachmentPath,
        }),
      });
    },

    sendDisparityCalculationFeedback: async (params: CreateDisparityCalculationFeedback): Promise<void> => {
      let attachmentPath: string | undefined;
      if (params.attachment) {
        const presignedPost = await getPresignedUrl(params.attachment);
        attachmentPath = await uploadToPresignedPost(presignedPost, params.attachment);
      }

      return apiClient('/feedbacks/', {
        method: 'POST',
        body: JSON.stringify({
          title: params.title,
          case_id: params.case_id,
          type_id: params.type_id,
          disparity_parameters: params.disparity_parameters,
          feedback: params.feedback,
          attachment_path: attachmentPath,
        }),
      });
    },
  };
};
